var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.42 511.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30419",
    d: "M456.11,17.09L107.85.08c-18.35-1.23-34.22,12.65-35.45,31-.1,1.48-.1,2.97,0,4.45l1.55,31.62c.59,10.18,4.95,19.77,12.24,26.9,7.16,7.36,16.79,11.83,27.03,12.56l203.4,10.15L9.7,423.69c-13.69,14.83-12.78,37.95,2.05,51.64.13.12.26.24.39.36l23.45,23.45c13.79,15.47,37.42,17.08,53.19,3.64L396.86,194.71l9.61,205.14c1.35,20.88,17.98,37.51,38.86,38.86l31.57,1.49c18.35,1.23,34.22-12.65,35.45-31,.1-1.48.1-2.97,0-4.45l-17.02-348.26c-1.49-21.05-18.24-37.8-39.29-39.29l.07-.11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow02);
export default __webpack_public_path__ + "static/media/arrow-02.06346506edc5125b99c21e7f309dec9f.svg";
export { ForwardRef as ReactComponent };